<div [ngClass]="baseService.isMobile ? 'd-flex flex-column gap-2 align-items-start' : 'd-flex align-items-center'">
  <app-search (onValueChange)="onSearchChange($event)"></app-search>
  @if (selectionTable.selected.length) {
    <div>
      <app-button #t="matMenuTrigger" [matMenuTriggerFor]="menu">
        <div class="d-flex w-100 align-items-center justify-content-between">
          <span class="selected_dropdown">({{ selectionTable.selected.length }}) {{ 'selected' | translate }}</span>
          <app-icon class="align-middle selected_dropdown">{{ t.menuOpen ? 'expand_less' : 'expand_more' }}</app-icon>
        </div>
      </app-button>
      <mat-menu #menu="matMenu" yPosition="below" xPosition="before" class="p-0">
        @for (item of bulkActionList; track item; let i = $index) {
          <button mat-menu-item (click)="bulkActionPopup(item)">
            {{ item.label | translate }}
          </button>
        }
      </mat-menu>
    </div>
  }
  @if (!baseService.isMobile) {
    <div class="flex-fill"></div>
  }
  <app-dropdown
    class="account-box"
    [ngClass]="{ 'w-100': baseService.isMobile }"
    [items]="items || []"
    [input]="currentChannelId || {}"
    [bindValue]="'id'"
    (onValueChange)="onValueChange($event)"
    [closeOnSelect]="true"
    [searchable]="true"
    placeholder="{{ 'channels' | translate }}"
  />
  <!--        <app-button (onChangeClick)="openDialogCreateChannel()">Створити канал</app-button>-->
</div>
@if (isLoader) {
  <div class="d-flex justify-content-center">
    <app-loader size="small"></app-loader>
  </div>
} @else {
  @if (dataSource$ | async; as dataSource) {
    <app-table
      class="w-100"
      [dataSource]="dataSource"
      [visibleColumnKeys]="visibleColumns"
      (onSortChange)="onSortChange($event)"
      (onPaginationChange)="onPaginationChange($event)"
      (menuSelected)="onActionChange($event)"
      [showUpPagination]="true"
      [selection]="selectionTable"
    ></app-table>
  }
}
